// Getters
export const suppliers = (state) => {
  return state.suppliers.data || []
}
export const suppliersLoading = (state) => {
  return state.suppliers.loading
}
export const suppliersLastUpdate = (state) => {
  return state.suppliers.lastUpdate
}

export const billsToPay = (state) => {
  return state.billsToPay.data || []
}
export const billsToPayLoading = (state) => {
  return state.billsToPay.loading
}
export const billsToPayLastUpdate = (state) => {
  return state.billsToPay.lastUpdate
}

export const departments = (state) => {
  return state.departments.data || []
}
export const departmentsLoading = (state) => {
  return state.departments.loading
}
export const departmentsLastUpdate = (state) => {
  return state.departments.lastUpdate
}

export const categories = (state) => {
  return state.categories.data || []
}
export const categoriesLoading = (state) => {
  return state.categories.loading
}
export const categoriesLastUpdate = (state) => {
  return state.categories.lastUpdate
}

export const billsStatus = (state) => {
  return state.billsStatus.data || []
}
export const fornecedores = (state) => {
  return state.fornecedores.data || []
}
export const fornecedoresLoading = (state) => {
  return state.fornecedores.loading
}
export const fornecedoresLastUpdate = (state) => {
  return state.fornecedores.lastUpdate
}

export const billsToReceive = (state) => {
  return state.billsToReceive.data || []
}
export const billsToReceiveLoading = (state) => {
  return state.billsToReceive.loading
}
export const billsToReceiveLastUpdate = (state) => {
  return state.billsToReceive.lastUpdate
}

export const servico = (state) => {
  return state.servico.data || []
}
export const servicoLoading = (state) => {
  return state.servico.loading
}
export const servicoLastUpdate = (state) => {
  return state.servico.lastUpdate
}

export const observationsBillsToReceive = (state) => {
  return state.observationsBillsToReceive.data || []
}
export const observationsBillsToReceiveLoading = (state) => {
  return state.observationsBillsToReceive.loading
}
export const observationsBillsToReceiveLastUpdate = (state) => {
  return state.observationsBillsToReceive.lastUpdate
}

export const pjs = (state) => {
  return state.pjs.data || []
}
export const pjsLoading = (state) => {
  return state.pjs.loading
}
export const pjsLastUpdate = (state) => {
  return state.pjs.lastUpdate
}
export const faturamentoAnexos = (state) => {
  return state.faturamentoAnexos.data || []
}
export const faturamentoAnexosLoading = (state) => {
  return state.faturamentoAnexos.loading
}
export const faturamentoAnexosLastUpdate = (state) => {
  return state.faturamentoAnexos.lastUpdate
}

export const solicitations = (state) => {
  return state.solicitations.data || []
}
export const solicitationsLoading = (state) => {
  return state.solicitations.loading
}
export const solicitationsLastUpdate = (state) => {
  return state.solicitations.lastUpdate
}
export const solicitationsPendingCount = (state) => {
  return state.solicitationsPendingCount.data || 0
}
export const solicitationsPendingCountLoading = (state) => {
  return state.solicitationsPendingCount.loading
}

export const filiais = (state) => {
  return state.filiais.data || []
}
export const filiaisLoading = (state) => {
  return state.filiais.loading
}
export const filiaisLastUpdate = (state) => {
  return state.filiais.lastUpdate
}

